/** Typography / colour tokens for the Max Pull block — Figma `1336:86230`.
 *
 * Flows through the `StatsRow` Design Constructor knobs. `StatsRow` themes
 * ONLY the Max Pull section (the block + its recap shown inside the modal);
 * the odds breakdown card/bars/mod use the separate `OddsBreakdown` system
 * (see `../OddsBreakdown/theme.ts`). Hex / rgba literals are `var(...,
 * fallback)` defaults only. See [[feedback_iframe_theme_vars]]. */

export const LABEL_COLOR = 'var(--co-StatsRow-labelColor, rgba(255,255,255,0.5))';
export const VALUE_COLOR = 'var(--co-StatsRow-valueColor, #ffffff)';
export const FONT = 'var(--co-StatsRow-fontFamily), Inter, system-ui, sans-serif';

// Responsive shrink factor applied ON TOP of the operator-set sizes. Defaults
// to 1 (no change); the narrow 800–1200px sidebar sets it to 0.85 (see
// OddsPanel) so the SIDE stats shrink ~15% from whatever size the operator
// picked, instead of overflowing its tight column. The centre "Max Pull"
// hero + its label are deliberately EXEMPT — they stay at the operator size.
//
// NOT a `--co-StatsRow-*` knob: it's an internal responsive multiplier set by
// a breakpoint utility, never by the operator, so it lives outside the
// Design-Constructor namespace (which the registry invariants guard).
const SIZE_SCALE = 'var(--statsRow-sizeScale, 1)';
// The phone shrinks the whole block, hero included (repackz-handoff §8.2:
// labels 13, sides 20, centre 32) — set on the phone's wrapper only.
const PHONE_SCALE = 'var(--statsRow-phoneScale, 1)';

// Centre "Max Pull" value is the visual hero — render it 50% larger than
// the side values. The centre label runs ≈ 15% over the side labels, so the
// hierarchy holds when the operator scales either size.
export const CENTER_VALUE_SIZE = `calc(var(--co-StatsRow-valueSize, 20px) * 1.5 * ${PHONE_SCALE})`;
export const CENTER_LABEL_SIZE = `calc(var(--co-StatsRow-labelSize, 13px) * 1.15 * ${PHONE_SCALE})`;

export const LABEL_SIZE = `calc(var(--co-StatsRow-labelSize, 13px) * ${SIZE_SCALE} * ${PHONE_SCALE})`;
export const VALUE_SIZE = `calc(var(--co-StatsRow-valueSize, 20px) * ${SIZE_SCALE} * ${PHONE_SCALE})`;
